export type AgentInputMode = "clickSpawn" | "dragPaint";

export const DEFAULT_AGENT_INPUT_MODE: AgentInputMode = "clickSpawn";
